module.exports = __webpack_public_path__ + "media/images/full-gallery-b0f94b6783415add956ba3b35e2ff0ee.png";